export default "/images/vendor/flag-icon-css/flags/4x3/pw.svg?5f3d8d8e8473f6439a214096e59c7636";